enum HighlightCardType {
  CHECKLIST = 'checklist',
  HIGHLIGHT = 'highlight',
  INFO = 'info',
  INFOLIST = 'infolist',
}
export default HighlightCardType;
